/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import {
  debouceTimeout,
  initialQueryState,
  KTIcon,
  useDebounce,
} from '../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponse} from '../../../../tipidkor/tipidkor-list/core/QueryResponseProvider'
import AttentonLevelSelect from '../../../../attention-level/components/AttentionLevelSelect'
import SatwilSelect from '../../../../satwil/components/SatwilSelect'
import DateRangePicker from '../../../../../components/DateRangePicker'
import moment from 'moment/moment'
import ReportStatusSelect from '../../../../report-status/components/ReportStatusSelect'

const JudolListSearchComponent = () => {
  const { updateState, state } = useQueryRequest()
  const { isLoading } = useQueryResponse()
  const [searchTerm, setSearchTerm] = useState<string>('')

  const [statusId, setStatusId] = useState<number|undefined>()
  const [attentionLevel, setAttentionLevel] = useState<number>(0)
  const [satwilId, setSatwilId] = useState<number|undefined>()
  const [startDate, setStartDate] = useState<string|undefined>()
  const [endDate, setEndDate] = useState<string|undefined>()
  const [keyword, setKeyword] = useState<string>('')

  const debouncedSearchTerm = useDebounce(searchTerm, debouceTimeout)

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
      updateState({ ...state, pageNumber: 1, keyword: debouncedSearchTerm })
    }
  }, [debouncedSearchTerm])

  const handleAttentionLevelChange = (option) => {
    // updateState({
    //   ...state,
    //   pageNumber: 1,
    //   filter: {
    //     ...state.filter,
    //     attentionLevel: option?.value || null
    //   }
    // })
    setAttentionLevel(option?.value || 0)
  }

  const handleSatwilChange = (option) => {
    // updateState({
    //   ...state,
    //   pageNumber: 1,
    //   filter: {
    //     ...state.filter,
    //     satwilId: option?.value || null
    //   }
    // })
    setSatwilId(option?.value)
  }

  const handleStatusChange = (option) => {
    // updateState({
    //   ...state,
    //   pageNumber: 1,
    //   status: option?.value,
    // })
    setStatusId(option?.value)
  }

  const handleDateChange = (dates) => {
    if (dates.length > 1) {
      // updateState({
      //   ...state,
      //   pageNumber: 1,
      //   filter: {
      //     ...state.filter,
      //     startDate: moment(dates[0]).toISOString(),
      //     endDate: moment(dates[1]).toISOString(),
      //   },
      // })
      setStartDate(moment(dates[0]).toISOString())
      setEndDate(moment(dates[1]).toISOString())
    } else {
      // updateState({
      //   ...state,
      //   pageNumber: 1,
      //   filter: {
      //     ...state.filter,
      //     startDate: null,
      //     endDate: null,
      //   },
      // })
      setStartDate(undefined)
      setEndDate(undefined)
    }
  }

  const handleFilter = () => {
    updateState({
      ...state,
      status: statusId,
      keyword: keyword,
      filter: {
        ...state.filter,
        attentionLevel: attentionLevel || null,
        satwilId: satwilId || null,
        startDate: startDate || null,
        endDate: endDate || null,
        v: new Date().toISOString(),
      }
    })
  }

  return (
    <div className='card-title row g-2 me-0'>
      <div className='col-md-4 col-xxl-2'>
        <ReportStatusSelect
          value={statusId}
          onChange={handleStatusChange}
          disabled={isLoading}
          className='w-100 fs-5'
          isClearable={true}
          placeholder='Status'
        />
      </div>
      <div className='col-md-3 col-xxl-2'>
        <AttentonLevelSelect
          value={attentionLevel}
          onChange={handleAttentionLevelChange}
          disabled={isLoading}
          className='w-100 fs-5'
          isClearable={true}
        />
      </div>
      <div className='col-md-5 col-xxl-3'>
        <SatwilSelect
          value={satwilId}
          onChange={handleSatwilChange}
          disabled={isLoading}
          className='w-100 fs-5'
          isClearable={true}
          placeholder='Wilayah'
        />
      </div>
      <div className='col-md-5 col-xxl-2'>
        <DateRangePicker
          label='Tanggal LP'
          startValue={startDate}
          endValue={endDate}
          disabled={isLoading}
          useFormik={false}
          onChange={handleDateChange}
          className='w-100 text-wrap pe-13 text-truncate'
          showToday={true}
          wrapperClass={['w-100']}
          isClearable={true}
        />
      </div>
      <div className='col-md-7 col-xxl-3'>
        <div className='d-flex align-items-center position-relative w-100'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-student-table-filter='search'
            className='form-control w-100 ps-14'
            placeholder='Keyword...'
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
          <button type='button' className='btn btn-icon btn-primary ms-2' onClick={handleFilter}>
            <i className='fa-solid fa-magnifying-glass ms-2 me-1'></i>
          </button>
        </div>
      </div>
    </div>
  )
}

export {JudolListSearchComponent}
